import { useRef, useState } from 'react';
import { useStyles } from './form-login-cliente-styles';
import { useFormLoginClienteValidation } from './form-login-cliente-validation';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@material-ui/core';
import { TextFieldSaurus } from 'components/inputs/text-field-saurus';
import { useThemeQueries } from 'components/dialogs/dialog-adicionar-produto-com-subitem/util-styles';
import { DefaultFormProps, DefaultFormRefs } from '../utils';
import { makeUtilClasses } from 'theme/util-make-styles';
import { CircularLoading } from 'components/utils/circular-loading';
import { LoginClienteFormModel } from 'models/app/forms/auth/login-cliente-form-model';
import { useEmpresaAtual } from 'services/hooks/empresa';
import { EnumConfigEmpresa } from 'models/enums/enum-config-empresa';
import { EnumTelaIdentificacao } from 'modulos/cardapio/containers/cardapio/cardapio-sacola/componentes/fases/identificacao-cliente/components/identificacao-fragment/components/use-identificacao-fragment';

interface FormLoginClienteProps extends DefaultFormProps<LoginClienteFormModel> {
    marginTop?: string;
    semAutocomplete?: boolean;
}

export const FormLoginCliente = React.forwardRef<
    DefaultFormRefs<LoginClienteFormModel>,
    FormLoginClienteProps
>((props: FormLoginClienteProps, refs) => {
    const txtEmail = useRef<HTMLInputElement>();
    const txtSenha = useRef<HTMLInputElement>();
    const { FormLoginYupValidation } = useFormLoginClienteValidation();
    const { getConfigByCod } = useEmpresaAtual()
    const utilClasses = makeUtilClasses();
    const classes = useStyles();
    const { isMobile } = useThemeQueries();
    const [model, setModel] = useState({
        modeloForm: new LoginClienteFormModel('')
    });

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm<LoginClienteFormModel>({
        resolver: yupResolver(FormLoginYupValidation),
        defaultValues: { ...model.modeloForm },
        criteriaMode: 'all',
        mode: 'onSubmit'
    });

    const hasIdenEmail = Number(getConfigByCod(EnumConfigEmpresa.soliClientesPorModeloTrabalho)) & EnumTelaIdentificacao.Email
    const onSubmit = (form: LoginClienteFormModel) => {
        form.usuario = hasIdenEmail ? form.usuario : form.usuario.replace(/\D+/g, '');
        props.onSubmit(form);
    };

    React.useImperativeHandle(refs, () => ({
        submitForm: async () => {
            await handleSubmit(onSubmit)();
        },
        resetForm: () => {
            reset();
            if (!isMobile) txtEmail?.current?.focus();
        },
        fillForm: (model: LoginClienteFormModel) => {
            setModel({ modeloForm: model });
            reset({ ...model });
            if (!isMobile) {
                if (model.usuario.length > 0) txtSenha?.current?.focus();
                else txtEmail?.current?.focus();
            }
        }
    }));



    return (
        <>
            <div className={utilClasses.formContainer}>
                {props.loading && props.showLoading ? (
                    <CircularLoading tipo="FULLSIZED" />
                ) : null}
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className={`${classes.formContainer} ${props.loading ? utilClasses.controlLoading : ''
                        }`}
                    style={{
                        marginTop: props.marginTop ? props.marginTop : undefined
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Controller
                                name="usuario"
                                control={control}
                                render={({ field }) => (
                                    <TextFieldSaurus
                                        tipo={hasIdenEmail ? "TEXTO" : "TELEFONE"}
                                        disabled={props.loading}
                                        fullWidth={true}
                                        className={classes.input}
                                        showStartAdornment={true}
                                        inputRef={txtEmail}
                                        allowSubmit={true}
                                        variant='outlined'
                                        autoComplete={
                                            'off'
                                        }
                                        label={hasIdenEmail ? "E-mail / Telefone" : "Telefone"}
                                        error={Boolean(errors.usuario && errors.usuario.message)}
                                        helperText={
                                            errors.usuario ? errors.usuario?.message : undefined
                                        }
                                        {...field}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Button style={{ display: 'none' }} type="submit"></Button>
                </form>
            </div>
        </>
    );
});
